import { NativeScrollEvent } from "react-native";

export function isCloseToBottom(ev: NativeScrollEvent) {
    const paddingToBottom = 20;
    return ev.layoutMeasurement.height + ev.contentOffset.y >=
        ev.contentSize.height - paddingToBottom;
};

export function areWeInIphone() {
    return window.navigator.userAgent.includes("iPhone") &&
        window.navigator.userAgent.includes("PWAShell");
}
